<script lang="ts">
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()

    import { mdiCheck } from "@mdi/js"
    import Icon from "./Icon.svelte"

    export let checked: boolean = false
    export let label: string = null
    export let radio: boolean = false
    export let cssClass: string = ""
    export let required: boolean = false
    export let disabled: boolean = false
    export let group: any = []
    export let value: any = null
    const toggle = () => {
        if (disabled) {
            return
        }
        if ((radio && !checked) || !radio) {
            checked = !checked
        }
        if (checked) {
            dispatch("checked")
        } else {
            dispatch("unchecked")
        }
    }
</script>

<input style="display: none" type="checkbox" bind:checked bind:group {required} {value} />
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="checkbox {cssClass}"
    class:checked
    class:disabled
    class:with-label="{label}"
    on:keydown|stopPropagation
    on:click|stopPropagation="{toggle}"
>
    <div class="input-checkbox">
        <div class="input-checkbox-content">
            {#if checked}
                <Icon path="{mdiCheck}" size="20px" />
            {/if}
        </div>
    </div>

    {#if label}
        <label for="">
            {label}
            <slot />
        </label>
    {/if}
</div>
